import axios, { AxiosRequestConfig } from 'axios';

import { PagedResponse } from '../types/api';
import { ReviewIssue } from '../types/ReviewIssue';

const URL = '/v2/review-issues';

class ReviewIssueService {
  static getByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<ReviewIssue>> {
    return axios.get(URL, config);
  }
}

export { ReviewIssueService };
